import * as React from 'react';

type EditingTableCellNameContextType = {
	editingTableCellName: string | null;
	setEditingTableCellName: (name: string | null) => void;

};

const defaultValue: EditingTableCellNameContextType = {
	editingTableCellName: null,
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	setEditingTableCellName: () => { },

};

export const EditingTableCellNameContext = React.createContext<EditingTableCellNameContextType>(defaultValue);

export const EditingTableCellNameProvider = ({ children }: { children: React.ReactNode; }) => {
	const [editingTableCellName, setEditingTableCellName] = React.useState<string | null>(null);

	const value = React.useMemo(() => ({ editingTableCellName, setEditingTableCellName }), [editingTableCellName]);

	return (
		<EditingTableCellNameContext.Provider value={value}>
			{children}
		</EditingTableCellNameContext.Provider>
	);
};

export function withEditingTableCellNameContext<P extends object, RefType = unknown>(
	WrappedComponent
) {
	const WithEditingTableCellName = React.forwardRef<RefType, P>((props, ref) => {
		return (
			<EditingTableCellNameProvider>
				<WrappedComponent {...props} ref={ref} />
			</EditingTableCellNameProvider>
		);
	});

	return WithEditingTableCellName;
}

